export const MIDDLE_DOT_STYLE =
  'before:w-xxs before:h-xxs before:mr-2xs before:bg-fg_secondary before:inline-block before:rounded-full before:content-[""]';
